import React from "react";
import { BlockConfig, Block } from "../types";
import { BlockRegistry } from "../BlockRegistryContext";

interface BlockRendererProps {
  blockConfig: BlockConfig;
  renderProps?: Record<string, any>;
}

export const BlockRenderer: React.FC<BlockRendererProps> = ({
  blockConfig,
  renderProps = {},
}) => {
  const block = BlockRegistry.getBlock(blockConfig.id);
  if (!block) return null;

  const BlockComponent = block.renderer as React.ComponentType<any>;
  return (
    <BlockComponent
      data={renderProps.data}
      variant={blockConfig.variant || "default"}
      settings={blockConfig.settings}
      className={blockConfig.className}
      style={blockConfig.style}
      {...renderProps}
    />
  );
};
